import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import classnames from 'classnames';

import Popover from 'components/popover/Popover';

import { __t, applyTranslations } from 'utils/language';
import { CHANNEL_TYPE_INSTAGRAM, CHANNEL_TYPE_TIKTOK } from 'utils/channels';

import './influencer-creator-network-list-popover.scss';

applyTranslations(require('./influencer-creator-network-list-popover.i18n.json'));

type Props = {
  identifier: string,
  parentInfluencerName?: string | null,
  triggerComponent: React.ReactNode,
  channel: typeof CHANNEL_TYPE_INSTAGRAM | typeof CHANNEL_TYPE_TIKTOK,
  type: 'follows' | 'channel',
  isCollabaryProfile?: boolean,
  metrics?: {
    followers: string,
    engagementRate: string
  }
};

const SANITIZE_HTML_CONFIG = {
  allowedTags: ['strong']
};

const MSG_KEY = 'influencer_creator_network_list_popover';

const InfluencerCreatorNetworkListPopover = (
  {
    channel,
    identifier,
    parentInfluencerName,
    triggerComponent,
    type,
    isCollabaryProfile,
    metrics
  }: Props
): JSX.Element => {
  const getPopoverText = (): string => __t(`${MSG_KEY}.tooltips.${type}`, {
    parentInfluencerName: parentInfluencerName || ''
  });

  const renderFollows = (): JSX.Element => (
    <div className="influencer-creator-network-list-popover__body">
      <div
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(getPopoverText(), SANITIZE_HTML_CONFIG)
        }}
      />
      <div>
        {__t(`${MSG_KEY}.tooltips.view_profile`, {
          profileType: isCollabaryProfile
            ? __t(`${MSG_KEY}.tooltips.view_profile_text`)
            : __t(`${MSG_KEY}.tooltips.open_${channel}_text`)
        })}
      </div>
    </div>
  );

  const renderChannel = (): JSX.Element => (
    <div className="influencer-creator-network-list-popover__body">
      <div className="influencer-creator-network-list-popover__body-title">
        {__t(`${MSG_KEY}.labels.${channel}`)}
      </div>
      <div className="influencer-creator-network-list-popover__body-metric">
        {__t(`${MSG_KEY}.labels.followers`)}: {metrics?.followers}
      </div>
      <div className="influencer-creator-network-list-popover__body-metric">
        {__t(`${MSG_KEY}.labels.engagement_rate`)}: {metrics?.engagementRate}
      </div>
    </div>
  );

  const popoverClasses = classnames('influencer-creator-network-list-popover', {
    [`influencer-creator-network-list-popover--type-${type}`]: Boolean(type)
  });

  return (
    <Popover
      key={`influencer-creator-network-list-popover--${identifier}`}
      classNameWrapper="influencer-creator-network-list-popover__wrapper"
      classNameTrigger="influencer-creator-network-list-popover__trigger"
      triggerComponent={triggerComponent}
    >
      <div className={popoverClasses}>
        {
          type === 'follows'
            ? renderFollows()
            : renderChannel()
        }
      </div>
    </Popover>
  );
};

export default InfluencerCreatorNetworkListPopover;
